<template>
	<v-dialog
		v-if="show"
		v-model="show"
		:max-width="maxWidth"
		persistent
		scrollable
	>
		<v-card>
			<v-card-title class="dialog-title py-3">
				<h5 class="title">{{ title }}</h5>
				<v-btn
					flat
					class="close-button"
					@click="$emit('close')"
				>
					<v-icon>clear</v-icon>
				</v-btn>
			</v-card-title>
			<v-divider />
			<v-card-text>
				<div
					class="dialog-content"
					:style="`height: ${contentHeight}`"
				>
					<v-progress-circular
						v-if="loading"
						class="loading"
						indeterminate
					/>
					<slot
						v-else
						name="content"
					/>
				</div>
			</v-card-text>
			<v-divider />
			<v-card-actions class="pa-2">
				<v-layout justify-end>
					<slot name="buttons" />
					<v-btn
						flat
						@click="$emit('close')"
					>
						Close
					</v-btn>
				</v-layout>
			</v-card-actions>
		</v-card>
	</v-dialog>
</template>

<script>
export default {
	props: {
		loading: { type: Boolean, default: false },
		show: { type: Boolean, default: false },
		maxWidth: { type: String, default: '800px' },
		contentHeight: { type: String, default: '60vh' },
		title: { type: String, default: 'Actions' },
	},
}
</script>

<style lang="scss" scoped>
.dialog-title {
	justify-content: center;
	position: relative;
	padding-left: 70px;
	padding-right: 70px;
	.close-button {
		position: absolute;
		top: 0;
		bottom: 0;
		right: 0;
		height: 100%;
		margin: 0;
		padding: 0;
		min-width: 60px;
	}
}
.dialog-content {
	position: relative;
	max-height: 60vh;
	.loading {
		position: absolute;
		top: 0;
		bottom: 0;
		left: 0;
		right: 0;
		margin: auto;
	}
}
</style>
